import { Component, EventEmitter, Input, Injectable, Output, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import { QueuesService } from '@app/_core/services/queues.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TransferWindowComponent } from 'src/app/pages/common/transfer-window/transfer-window.component';
import { BehaviorSubject, EMPTY } from 'rxjs';
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-announced-transfer',
  templateUrl: './announced-transfer.component.html',
	styleUrls: ['./announced-transfer.component.scss'],
  
	changeDetection: ChangeDetectionStrategy.Default
})
export class AnnouncedTransferComponent {
	/*@Output() CallTransfer_internalCallInProgress: EventEmitter<any> = new EventEmitter<any>();*/
	modalRef?: BsModalRef;
	currTransfer: any;
	step2Hdr1Text: any;
	step2Hdr2Text: any;
	isvalueupdated: boolean = false;
	step2ToggleCaller: any='test';
	step2ToggleBtn: any = {};
	//step2CompleteBtn: boolean = false;
	step2CompleteBtn: any = {};
	step2CompleteBtn_enabled: any;
	step2CompleteBtn_label: any;
	step2CompleteBtn_tooltip: any;

	step2ToggleBtn_enabled: any;
	step2ToggleBtn_label: any;
	step2ToggleBtn_tooltip: any;

	step2ResumeBtn_enabled: any;
	step2ResumeBtn_label: any;
	step2ResumeBtn_tooltip: any;

	step2ResumeBtn: any = {};
	step2VoicemailBtn: any = {};

	step2VoicemailBtn_enabled: any;
	step2VoicemailBtn_label: any;
	step2VoicemailBtn_tooltip: any;

	step2AgentText: any;
	isGroup: any;
	transferCallID: any;
	onWithCaller: any;
	pendingToggle: any;
	internalCallStart: any;
	title: any;
	step2CallerText: any = {};		
	callerHungUp: any = {};
	agentHungUp: any = {};
	caller: any;
	agent: any;
	completeTransferClicked: boolean=false;
	callConnectedSnd: any = new Audio("https://common.cts-connect.com/Audio/newCallTone-alt.wav");
	constructor(public bsModalRef: BsModalRef, private queueServices: QueuesService, private transferWindowComponent: TransferWindowComponent,
		private cd: ChangeDetectorRef, private modalService: BsModalService
	) {

		
	}
	public currentMenu: BehaviorSubject<any> = new BehaviorSubject<any>('Test3');

	ngOnInit() {
		
		this.loadData();
	}

	initdialog() {
		const initialState = {
			
			currTransfer: this.currTransfer
		};

		const config: ModalOptions = {
			backdrop: 'static',
			keyboard: false,
			class: 'confirm-dialog modal-wd-290',
			initialState,
		};
		// const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
		this.modalRef = this.modalService.show(AnnouncedTransferComponent, config);
    }

	loadData() {
		if (this.currTransfer) {
			this.displayStep2(this.currTransfer);
			this.queueServices.setCurrentTransferData(this.currTransfer);

		}
    }
	

  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
	}
	Getdata(variableName) {
		let currTransfer = this.queueServices.getCurrentTransferData();
		return currTransfer[variableName];
    }
	internalCallInProgress = function (caller, agent) {
	
		//if we're in the middle of a group transfer, then allow toggle and complete now that the internal call was answered
		let currTransfer = this.queueServices.getCurrentTransferData();
		this.step2ToggleCaller = ((this.onWithCaller) ? ((caller == null) ? '' : caller) : ((agent == null) ? '' : agent));
		
		currTransfer.step2ToggleCaller = this.step2ToggleCaller;
		
	
		if (!this.completeTransferClicked) {
			this.step2CompleteBtn_enabled=true;
			this.step2ToggleBtn_enabled = true;

			currTransfer.step2CompleteBtn_enabled = this.step2CompleteBtn_enabled;
			currTransfer.step2ToggleBtn_enabled = this.step2ToggleBtn_enabled;
		}
		if (this.onWithCaller) {//&& self.currentStep() == 2) {
			this.step2AgentText=('The transfer recipient has answered the call.');
			if (this.internalCallStart) {
				this.internalCallStart = false;
				this.callConnectedSnd.play();
				if (this.transferCallID != null) {
					//self.controller().holdTransferRecipient(transferCallID);
				}
				//$(step2AgentText._cl_viewElement).toggleClass('flashing', true);
			}
		} else {
			this.step2AgentText = ('When you are ready,<br />choose one of the following options.');
			currTransfer.step2AgentText = this.step2AgentText;
		}

		this.queueServices.setCurrentTransferData(currTransfer);
	}
	eStep2CompleteBtnClickHandler = function () {
		this.currTransfer = this.queueServices.getCurrentTransferData();
		this.completeTransferClicked = true;
		this.step2CompleteBtn.enabled=false;
	//cls.cl().main().mainController().phoneController().isTransferViewActive(false);
		var data = this.currTransfer;
	if (data.type != "announced" && data.type != "attended") {
		//cls.cl().main().mainController().toggleHold(null, false);
	}
	var type = 'blind';
	switch (data.type) {
		case "attended":
			//cls.cl().main().mainController().phoneController().disableControlAttended();
			break;
		case "conference":
			type = 'conference';
			break;
		case "externalAttended":
			//cls.cl().main().mainController().phoneController().disableControlAttended();
			break;
		case "externalConference":
			type = 'externalConference';
			break;
		case "announced":
		case "completeAnnounced":
			type = "completeAnnounced";
			break;
		case "externalAnnounced":
		case "completeExternalAnnounced":
			type = "completeExternalAnnounced";
			break;
		case "add":
		case "externalAdd":
		case "completeadd":
			type = "completeadd";
			break;
		case "groupAnnounced":
		case "completeGroupAnnounced":
			type = "completeGroupAnnounced";
			break;
		case "groupAttended":
			type = 'completeGroupAttended';
			//cls.cl().main().mainController().phoneController().disableControlAttended();
			break;
		case "completeGroupAttended":
			type = "completeGroupAttended";
			break;
	}
	//if ((transferCallID != null) && (typeof transferCallID === 'string') && (transferCallID.length > 0)) {
	//	self.dispatchEvent(im.CallEvent.RESUME, { id: transferCallID, skipHide: true, isGroup: isGroup, step2Cancel: false });
	//}
	//self.dispatchEvent(im.CallEvent.TRANSFER, { id: data.id, type: type, name: data.name, step2Cancel: false });
		this.transferWindowComponent.CallEvent_TRANSFER.emit({ data: this.currTransfer, type: type, step2Cancel: false});
}

	displayStep2 = function (currTransferData) {
		var data = currTransferData;
		//$(this._cl_viewElement).removeClass('TransferStep1 TransferStep3').addClass('TransferStep2');
		this.title=((data != null && data.hasOwnProperty('typeName')) ? data.typeName : 'Add to Conference');
		var isAdd = (this.title.indexOf('Add ') == 0);
		this.isGroup = data.type == 'groupAnnounced' || data.type == 'groupAttended';
		this.step2Hdr1Text =('Recipient: ' + ((data != null && data.hasOwnProperty('Name')) ? data.Name : 'Third Party'));
		this.step2Hdr2Text =('On Call: ' + this.getUserName());
		//step2ToggleState.text('On with Transfer');
		//step2ToggleCaller.text('');
		this.step2ToggleBtn_enabled=false;
		this.step2AgentText = (this.isGroup ? 'You may complete the transfer<br />once the recipient is on the line.' : 'When you are ready,<br />choose one of the following options.');
		this.step2CompleteBtn_enabled = false;
		this.step2CompleteBtn_label=('Complete ' + (isAdd ? 'Add' : 'Transfer'));
		this.step2CompleteBtn_tooltip=((isAdd) ? 'Add the recipient to the conference call.' : 'Transfer the user to the recipient.  If Announced, you will be disconnected.  If Attended, you will stay on the line.');
		this.step2ResumeBtn_label=(isAdd ? 'Cancel Add' : 'Cancel Transfer');
		this.step2ResumeBtn_tooltip=((isAdd) ? 'Cancel the add and resume your call with the user.' : 'Cancel the transfer and resume your call with the user.');
		this.step2VoicemailBtn_visible=(data != null && data.type != "externalAttended" && data.type != "externalAnnounced" && data.type != 'externalAdd' && !this.isGroup);
		this.step2VoicemailBtn_enabled = false;

		currTransferData.step2ToggleBtn_enabled = this.step2ToggleBtn_enabled;
		currTransferData.step2CompleteBtn_enabled = this.step2CompleteBtn_enabled;
		currTransferData.step2CompleteBtn_label = this.step2CompleteBtn_label;
		currTransferData.step2CompleteBtn_tooltip = this.step2CompleteBtn_tooltip;
		currTransferData.step2ResumeBtn_label = this.step2ResumeBtn_label;
		currTransferData.step2ResumeBtn_tooltip = this.step2ResumeBtn_tooltip;
		currTransferData.step2VoicemailBtn_visible = this.step2VoicemailBtn_visible;
		currTransferData.step2VoicemailBtn_enabled = this.step2VoicemailBtn_enabled;

		this.setCallerDisplay(this.callerHungUp);
		//$(step2AgentText._cl_viewElement).removeClass('flashing');
		//step1.visible(false);
		//step3.visible(false);
		this.transferCallID = null;
		this.onWithCaller = false;
		this.pendingToggle = false;
		this.internalCallStart = true;
		//if (this._qbr_modal != null) {
		//	this._qbr_modal.contentView().width(350);
			//this.cl().main().mainController().phoneController().isTransferViewActive(true);
		//	if (this.cl().main().mainController().phoneController().externalSystem())
		//		this._qbr_modal.contentView().alignX('right').alignY('top').x(-10).y(145);
		//}
		//this.width(350).height(420);
		//step2.visible(true);

		this.queueServices.setCurrentTransferData(currTransferData);
	}
	 setCallerDisplay = function (hungUp) {
		this.step2CallerText.text=(this.callerHungUp ? 'THE CALL WITH THE CUSTOMER HAS ENDED.' : '');
		if (hungUp) {
			this.step2CompleteBtn_enabled=false;
			this.step2ToggleBtn_enabled=false;
			this.step2VoicemailBtn_enabled=false;
		}

		 if (this.callerHungUp && this.agentHungUp) {
			//cls.cl().main().mainController().phoneController().stopCallDurationTimer();
		}
	}
	getUserName = function () {
	//if (!options.User || !options.User.FullName) {
	//	return "New/Unknown User";
	//}
		var userName = '';//(options.User.FullName == '') ? options.User.Company : options.User.FullName;
	return userName;
}
}
